// extracted by mini-css-extract-plugin
module.exports = {"news-social":"News_news-social__AvIBh","news-items-item":"News_news-items-item__glh2V"};